'use strict';

const connectToNavBar = require('../core/nav/helpers/connectToNavBar.es');
const connectToContact = require('../../contact/shared/helpers/connectToContact.es');
const { createReducerStore } = require('fluxible-reducer-store');
const appFactory = require('./appFactory.es');

const RegionalInfoStore = require('../stores/RegionalInfoStore.es');
const UserStore = createReducerStore(require('../stores/UserStore.es'));
const PortfolioStore = require('../stores/PortfolioStore');
const ContactDealerStore = createReducerStore(require('../../newPdp/stores/ContactDealerStore.es'));

const StickyAlertTopStore = require('../../components/StickyAlert/StickyAlertTop/StickyAlertTop-store');
const CalloutStore = require('../../components/Callout/CalloutStore');

/**
 * Setups Fluxible App for use on the server and client.
 *
 * Registers the stores needed to communicate with the global nav bar and
 * registers RegionalInfoStore needed to communicate with global user auth modal,
 *
 * @param {Array} [stores=[]] - Array of stores to register onto App
 * @param {Object} [options={}]
 * @param {boolean} [options.connectToNavBar=true] - If true, register Nav Bar stores with the app
 * @returns {Object} - Fluxible App
 */
function appSetup(stores = [], options = {}) {
    let App = appFactory(stores);

    if (options.connectToNavBar) {
        App = connectToNavBar(App);
    }
    if (options.connectToContact) {
        App = connectToContact(App, options.contactOptions);
    }

    App.registerStore(RegionalInfoStore);
    App.registerStore(UserStore);
    App.registerStore(PortfolioStore);
    App.registerStore(ContactDealerStore);

    App.registerStore(StickyAlertTopStore);

    App.registerStore(CalloutStore);

    return App;
}

module.exports = appSetup;



// WEBPACK FOOTER //
// ./assets/js/global/reactHelpers/appSetup.es.js